import { baseApi } from "./baseApi";
import { API_ENDPOINTS } from "../../config/url";

export interface Order {
    _id: string;
    userId: string;
    user?: {
        _id: string;
        name: string;
        email: string;
        phone: string;
        profilePhoto?: string;
    };
    status: number;
    paymentStatus: number;
    paymentMode: number;
    totalAmount: number;
    grandTotal: number;
    loyaltyPointsRedeemed: number;
    deliveryAddress: {
        name: string;
        phone: string;
        countryCode: string;
        address: string;
        landmark: string;
        city: string;
        state: string;
        pincode: string;
    };
    statusHistory: Array<{
        status: number;
        createdAt: string;
        _id: string;
    }>;
    deliveryOption: number;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    suborders: Array<{
        _id: string;
        quantity: number;
        price: number;
        totalPrice: number;
        subtotal: number;
        toppingPrice: number;
        grandTotal: number;
        type: number;
        product: {
            _id: string;
            image: string;
            name: string;
        };
        yogurtFlavors: any[];
        yogurtToppings: any[];
        greekBoxFlavors: any[];
        greekBoxToppings: any[];
    }>;
}

export interface OrdersResponse {
    statusCode: number;
    message: string;
    data: {
        order: Order[];
        totalCount?: number;
    };
}

export const orderApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getOrders: builder.query<OrdersResponse, { search?: string; status?: string | number, page?: number, limit?: number, userId?: string }>({
            query: (params) => ({
                url: API_ENDPOINTS.ORDERS.LIST,
                method: "GET",
                params,
                headers: {
                    "x-portal": "admin",
                },
            }),
            providesTags: ["ORDER"],
        }),
        getOrderDetails: builder.query<any, string>({
            query: (id) => ({
                url: API_ENDPOINTS.ORDERS.DETAIL(id),
                method: "GET",
            }),
            providesTags: ["ORDER"],
        }),
        updateOrderStatus: builder.mutation<any, { orderId: string, status: number }>({
            query: (body) => ({
                url: API_ENDPOINTS.ORDERS.STATUS_UPDATE,
                method: "PUT",
                body,
                headers: {
                    "x-portal": "admin",
                },
            }),
            invalidatesTags: ["ORDER"],
        }),
    }),
});

export const { useGetOrdersQuery, useGetOrderDetailsQuery, useUpdateOrderStatusMutation } = orderApi;
